import React from "react";
import {useSelector} from "react-redux";
import users from "../../../users";
import {FormattedMessage} from "react-intl";
import {formatFileSize} from "../../../../utils/utils";
import {Link} from "react-router-dom";

function UserSizeData(){

    const sizeData = useSelector(users.selectors.getSizeData);
    const config = useSelector(users.selectors.getUserConfiguration);

    if(!sizeData){
        return null;
    }

    function getSizeWarnClass(){
        if(sizeData.percentage < 60){
            return 'bg-success';
        }
        if(sizeData.percentage < 80){
            return 'bg-warning';
        }
        return 'bg-danger'
    }



    return (
        <div className="col-12 mb-3">
            <div className="progress mb-2">
                <div className={"progress-bar " + getSizeWarnClass()} role="progressbar" style={{width: sizeData.percentage + "%"}} aria-valuenow={sizeData.percentage}
                     aria-valuemin="0" aria-valuemax="100">
                </div>
            </div>
            <div className="">
                <div>
                    <FormattedMessage
                        id="drive.user-size.total-size-info"
                        values={{ usedSize: formatFileSize(sizeData.currentSize, true), totalSize: formatFileSize(sizeData.totalSize, true) }}/>
                </div>
            </div>
        </div>
    )
}

export default UserSizeData;
